/**
 * Rounds a number down to the nearest hundred, preserving sign.
 * If the absolute value is between 0 and 100, it rounds up to 100.
 */
export function roundAbsToHundred(value: number): number {
    const sign = value < 0 ? -1 : 1;
    const abs = Math.abs(value);
    const rounded = abs > 0 && abs < 100 ? 100 : Math.floor(abs / 100) * 100;
    return sign * rounded;
}
